import React, { useEffect, useState, useCallback } from 'react'
import { useLocation } from 'react-router-dom'
import { paginate } from '../../api/paginate'
import { useTheme } from '../../hooks/useTheme'
import ResponsiveTable from '../commons/ResponsiveTable'
import { Listaringreso } from './Listaringreso'
import { Container, Tab, Tabs } from 'react-bootstrap'
import { FaList, FaSitemap, FaUser, FaClipboardList } from 'react-icons/fa'
import { ColaIngresados } from './ColaIngresados'
import LotesList from '../mediciones/lotes/LotesList'
import PlantillasList from '../mediciones/plantillas/PlantillasList'
import './Settinglistingreso.css'

export const Settinglistingreso=()=> {
    const [ingresos, setIngreso]=useState([])

    const [page,setPage] = useState(1)
    const {size} = useTheme()
    const location = useLocation()
    // Permite navegar a esta vista pre-activando un tab específico via
    // `navigate('/Ingresos/listar', { state: { activeTab: 'lotesCal' } })`.
    // Sin state, arranca en 'ingresosList' como siempre.
    const [activeTab, setActiveTab] = useState(location.state?.activeTab || 'ingresosList');

    // Si el usuario vuelve a esta ruta con nuevo state (p. ej. tras anular un
    // lote), sincroniza el tab activo con el state entrante.
    useEffect(() => {
      if (location.state?.activeTab) setActiveTab(location.state.activeTab);
    }, [location.state?.activeTab, location.key]);

    // Refresh reactivo Cola → Lotes (spec lotes-cola-lotes-refresh-reactivo).
    // Cuando se crea un lote desde ColaIngresados, bumpea el key; LotesList lo
    // incluye en las deps de su fetch y re-consulta.
    const [refreshLotesKey, setRefreshLotesKey] = useState(0);
    const bumpLotesRefresh = useCallback(() => setRefreshLotesKey(k => k + 1), []);

    useEffect(()=>{
      async function getDataingreso(){
      //const consulta = await getDataList('I|ngresoEquipos',{options:{sort:{fechaIngreso:-1}}})
      const consulta = await paginate(`/IngresoEquipos/paginar?page=${page}&perPage=30`,{conditions:{}, sort:{fechaIngreso:-1}})
      //console.log(consulta.data.data)
      setIngreso(consulta.data.data)
      }
      getDataingreso()
  },[page])

  return (
    <Container className='setting-ingresos-container'>
      <div className='setting-ingresos-header'>
        <h2 className='setting-ingresos-title'>Gestión de Ingresos de Equipos</h2>
        <p className='setting-ingresos-subtitle'>Administre listados, cola de ingresos y lotes de calibración en un solo panel.</p>
        </div>
      <Tabs
           id="ingresosTab"
          activeKey={activeTab}
          onSelect={(k) => setActiveTab(k || 'ingresosList')}
        className="mb-4 border-bottom-0 ingresos-tabs"
        >
          <Tab

            eventKey="ingresosList"
            title={
              <span>
                <FaList className="me-2" />
                Lista Ingresos
              </span>
            }
          >
          <ResponsiveTable>
            <Listaringreso ingresos={ingresos}  setIngreso={setIngreso} page={page} setPage={setPage} />
          </ResponsiveTable>
          </Tab>
          <Tab
            eventKey="colaIngresados"
            title={
              <span>
                <FaSitemap className="me-2"/>
                Cola Ingresados
              </span>

            }>
              <ColaIngresados onLoteCreado={bumpLotesRefresh} />
            </Tab>
            <Tab
              eventKey="lotesCal"
              title={
                <span>
                  <FaUser className="me-2"/>
                  Lotes Calibración
                </span>
              }
              >
                <LotesList refreshKey={refreshLotesKey} />
            </Tab>
            <Tab
              eventKey="plantillas"
              title={
                <span>
                  <FaClipboardList className="me-2"/>
                  Plantillas
                </span>
              }
              >
                <PlantillasList />
            </Tab>
        </Tabs>

    </Container>
  )
}
